import { render, staticRenderFns } from "./colleges.vue?vue&type=template&id=c3f82088&scoped=true&"
import script from "./colleges.vue?vue&type=script&lang=js&"
export * from "./colleges.vue?vue&type=script&lang=js&"
import style0 from "./colleges.vue?vue&type=style&index=0&id=c3f82088&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f82088",
  null
  
)

export default component.exports